import { render, staticRenderFns } from "./CallsTable.vue?vue&type=template&id=2cc1481d&scoped=true&"
import script from "./CallsTable.vue?vue&type=script&lang=js&"
export * from "./CallsTable.vue?vue&type=script&lang=js&"
import style0 from "./CallsTable.vue?vue&type=style&index=0&id=2cc1481d&lang=scss&scoped=true&"
import style1 from "./CallsTable.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc1481d",
  null
  
)

export default component.exports